import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  IconButton,
  LinearProgress,
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import PageHeader from "../../../common/PageHeader";
import "../styles/DDSelection.css";
import { navigationOptions } from "../../../common/navigation-bars/navigationOptions";
import FinancialCard from "../components/DDQSelectionCard";
import CustomCard from "../../../common/CustomCard";
import secureLocalStorage from "react-secure-storage";
import {
  apiClient,
  getDDQuestionerDataByCompanyId,
} from "../services/apiClient";
import DDQSelectionCard from "../components/DDQSelectionCard";
import { ddqSelectionCardData } from "../data/ddqDashboardData";
import ActionButton from "../../../common/input-fields/ActionButton";
import { Player } from "@lottiefiles/react-lottie-player";
import { getDDQStatistics } from "../services/apiClient";
import { selectDDQ } from "../services/api";
import demoData from "../services/demoData";
import CloseIcon from "@mui/icons-material/Close";

const DDSelection = () => {
  //#region variables
  const companyId = secureLocalStorage.getItem("selectedCompanyId");
  // console.log("dddddddddddd",companyId)
  const [selectionTypes, setSelectionTypes] = useState([]);
  const [selectedTypes, setSelectedTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isGenerating, setIsGenerating] = useState(false);
  const navigate = useNavigate();
  const [statistics, setStatistics] = useState({
    ddTypesSelected: 0,
    totalQuestions: 0,
    avgReadiness: 0,
  });

  const getDDSelectionTypes = async () => {
    setLoading(true);
    const response = await getDDQStatistics();
    if (response?.success) {
      const formatted = response.data.typesWithPillars.map((type) => ({
        id: type.id,
        name: type.name,
        status: "Recommended",
        progress: Math.floor(Math.random() * 100),
        questions: response.data.totalQuestions,
      }));

      setSelectionTypes(formatted);

      // Update stats dynamically
      const totalQuestions = response.data.totalQuestions;
      const ddTypesSelected = formatted.length;
      const avgReadiness = Math.floor(
        formatted.reduce((acc, curr) => acc + curr.progress, 0) /
          formatted.length
      );

      setStatistics({
        ddTypesSelected,
        totalQuestions,
        avgReadiness,
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    getDDSelectionTypes();
  }, []);

  const generateDDQ = async () => {
    if (selectedTypes.length === 0)
      return alert("Please select at least one DD type");

    try {
      setIsGenerating(true);
      console.log("Company ID:", companyId);
      console.log("Selected DD Type IDs:", selectedTypes);
      //Make an api call
      // select ddq
      //For the demo selectedType is always at index 0 (Tech due diligence)

      //NOTE: For the MVP selectedTypes will be kept as array

      //Show the model

      const selectDDQResponse = await selectDDQ(
        companyId,
        selectedTypes[0],
        demoData.createdBy
      );
      // await new Promise((resolve) => setTimeout(resolve, 1000));

      //Disable model state

      navigate("/due-diligence/ddq-dashboard");
    } catch (err) {
      console.error("Failed to generate DDQ:", err);
      alert("Failed to generate DDQ. Please try again.");
    } finally {
      setIsGenerating(false);
    }
  };

  //#region return
  return (
    <Box p={2}>
      <PageHeader
        title="Due Diligence Selection - TechFlow Solutions"
        description="Choose the types of due diligence to conduct for this SaaS/PaaS company"
        actionButton={
          // <Button
          //   variant="contained"
          //   sx={{
          //     backgroundColor: "#1F61C5",
          //     height: "45px",
          //     borderRadius: "8px",
          //     border: "none !important",
          //     textTransform: "none !important",
          //     "&:hover": { backgroundColor: "#174a99" },
          //   }}
          // >
          //   Select DDQ ({statistics.totalQuestions} Questions)
          // </Button>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#1F61C5",
              height: "45px",
              borderRadius: "8px",
              border: "none !important",
              textTransform: "none !important",
              "&:hover": { backgroundColor: "#174a99" },
            }}
            onClick={generateDDQ}
            disabled={isGenerating}
          >
            {/* {isGenerating
              ? "Please wait while we import the questions..."
              : `Select DDQ (${statistics.totalQuestions} Questions)`} */}
            Select DDQ ({statistics.totalQuestions} Questions)
          </Button>
        }
        selectOptions={navigationOptions}
      />
      <Dialog
        open={isGenerating}
        maxWidth="xs"
        fullWidth
        onClose={() => setIsGenerating(false)}
      >
        <IconButton
          aria-label="close"
          onClick={() => setIsGenerating(false)}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
            py: 4,
          }}
        >
          <CircularProgress size={40} color="primary" />

          <Typography
            variant="h6"
            sx={{ fontWeight: 600, textAlign: "center", mt: 2 }}
          >
            Please Wait
          </Typography>

          <Typography
            variant="body2"
            sx={{ textAlign: "center", color: "text.secondary" }}
          >
            We're importing the due diligence questions for your selection. This
            may take a few moments.
          </Typography>
        </DialogContent>
      </Dialog>

      <Grid container spacing={2}>
        <Grid item size={{ xs: 12 }}>
          <CustomCard>
            <Box sx={{ display: "flex", alignItems: "flex-start", gap: "5px" }}>
              {/* Lottie Player */}
              <Player
                autoplay
                loop
                src="/animations/bluePulse.json"
                style={{ width: 30, height: 30 }}
              />

              {/* Text Stack */}
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Typography sx={{ fontSize: 18, fontWeight: 400, mb: 1 }}>
                  AI Recommendations Based on Uploaded Documents
                </Typography>

                <Typography
                  sx={{
                    fontSize: 16,
                    fontWeight: 400,
                    color: "#0a1a27",
                    opacity: 0.67,
                    mb: 2,
                  }}
                >
                  Our AI has analyzed your uploaded documents and suggests
                  focusing on these due diligence areas. You can modify the
                  selection based on your specific requirements.
                </Typography>

                <Box sx={{ display: "flex", gap: 4 }}>
                  <Typography sx={{ fontSize: 14, fontWeight: 400 }}>
                    Financial statements detected
                  </Typography>
                  <Typography sx={{ fontSize: 14, fontWeight: 400 }}>
                    Legal agreements found
                  </Typography>
                  <Typography sx={{ fontSize: 14, fontWeight: 400 }}>
                    Tech infrastructure docs available
                  </Typography>
                </Box>
              </Box>
            </Box>
          </CustomCard>
        </Grid>
        <Grid item size={{ xs: 12 }}>
          <Grid container spacing={2}>
            {loading ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: "150px",
                  width: "100%",
                }}
              >
                <CircularProgress />
              </Box>
            ) : (
              <Grid container spacing={2}>
                {selectionTypes.map((selectionData, index) => (
                  <Grid
                    item
                    key={selectionData.id || index}
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                  >
                    <DDQSelectionCard
                      selectionData={selectionData}
                      progress={selectionData.progress}
                      questions={selectionData.questions}
                      checked={selectedTypes.includes(selectionData.id)}
                      onChange={(checked) => {
                        if (checked) {
                          setSelectedTypes([
                            ...selectedTypes,
                            selectionData.id,
                          ]);
                        } else {
                          setSelectedTypes(
                            selectedTypes.filter(
                              (id) => id !== selectionData.id
                            )
                          );
                        }
                      }}
                    />
                  </Grid>
                ))}
              </Grid>
            )}
          </Grid>
        </Grid>
        <Grid item size={{ xs: 12 }} sx={{ alignSelf: "flex-end" }}>
          <CustomCard>
            {/* Title */}
            <h2 style={{ marginBottom: "16px", marginTop: 0 }}>
              Financial Due Diligence
            </h2>

            {/* Stats Row */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                textAlign: "center",
                px: 2,
              }}
            >
              {/* First Stat */}
              <Box>
                <Typography sx={{ fontSize: 35, fontWeight: 700 }}>
                  {statistics.ddTypesSelected}
                </Typography>
                <Typography
                  sx={{
                    fontSize: 12,
                    fontWeight: 400,
                    color: "#0a1a27",
                    opacity: 0.67,
                  }}
                >
                  DD Types Selected
                </Typography>
              </Box>

              {/* Second Stat */}
              <Box>
                <Typography sx={{ fontSize: 35, fontWeight: 700 }}>
                  {statistics.totalQuestions}
                </Typography>
                <Typography
                  sx={{
                    fontSize: 12,
                    fontWeight: 400,
                    color: "#0a1a27",
                    opacity: 0.67,
                  }}
                >
                  Total Questions
                </Typography>
              </Box>

              {/* Third Stat */}
              <Box>
                <Typography sx={{ fontSize: 35, fontWeight: 700 }}>
                  {statistics.avgReadiness}%
                </Typography>
                <Typography
                  sx={{
                    fontSize: 12,
                    fontWeight: 400,
                    color: "#0a1a27",
                    opacity: 0.67,
                  }}
                >
                  Avg. Readiness
                </Typography>
              </Box>
            </Box>
          </CustomCard>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DDSelection;
